import React from 'react';
import { Children, IPropsWithClassName } from 'interfaces';

import styles from './styles';

export interface ResultsRowProps extends IPropsWithClassName {
  label: Children,
  value: Children,
}

const ResultsRow = ({
  label,
  value,
  className,
  ...props
}: ResultsRowProps) => {
  const componentStyles = styles.component(className);

  return (
    <div
      className={componentStyles}
      {...props}
    >
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
};

export default ResultsRow;
